import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDebounce } from '~/hooks/useDebounce'
import { SearchData } from '~/components/Content/SearchBlock/data'

type SearchItem = {
  placeholder?: string
  contentType?: Array<{ id: string }>
  keyword?: string
}

export function useSearchAutocomplete(search?: SearchItem[]) {
  const [searchTerm, setSearchTerm] = useState('')
  const debouncedSearchTerm = useDebounce(searchTerm, 400)

  const pageSize = 5
  const type =
    search && Array.isArray(search[0]?.contentType)
      ? search[0].contentType.map(ct => ct.id)
      : []
  const keyword = (search && search[0]?.keyword) || ''

  // console.log('hook', search)
  // console.log('Search Type:', pageSize, type, keyword)

  const { data: searchResults, isSuccess } = useQuery({
    queryKey: ['minilistData', debouncedSearchTerm, pageSize, type, keyword],
    queryFn: () => SearchData(debouncedSearchTerm, pageSize, type, keyword),
    enabled: debouncedSearchTerm.trim().length > 0
  })

  const handleQueryChange = (value: string) => setSearchTerm(value)

  const mappedItems = (searchResults || []).map(entry => ({
    entryTitle: entry.seoStandard.title || '',
    sys: {
      uri: entry.sys.uri || '',
      id: entry.sys.id || ''
    },
    seoStandard: {
      title: entry.seoStandard.title || '',
      description: entry.seoStandard.description || '',
      search: true
    }
  }))

  return {
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
    mappedItems,
    isSuccess,
    handleQueryChange
  }
}
